/* OpticalH touch, responsive and support enhancements — 2026-07-20 */
(() => {
  const MOTIVE_STYLE_ID = 'oh-touch-motive-v2';
  const MOTIVE_CSS = `
    :host {
      color-scheme: light;
      --oh-search-ink: #1d1d1f;
      --oh-search-muted: #6e6e73;
      --oh-search-soft: #f5f5f7;
      --oh-search-control-active: #e8e8ed;
      --oh-search-hairline: rgba(29, 29, 31, .1);
      --oh-search-radius-control: 14px;
      --oh-search-radius-compact: 12px;
      --oh-search-radius-card: 16px;
      /* OH MOTIVE OVERLAY POLISH V9 · 2026-07-21 */
    }

    .x-mot-layout,
    .x-mot-layout__main,
    .x-mot-layout__main-body,
    .x-mot-layout__main-scroll,
    .x-mot-empathize,
    .x-no-query {
      background: #fff !important;
    }

    .x-mot-brand-logo {
      min-height: 48px !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .x-mot-brand-logo__image {
      filter: grayscale(1) contrast(1.35) brightness(.12) !important;
    }

    .x-events-modal-close-button,
    .x-mot-close,
    .x-mot-cart {
      width: 48px !important;
      min-width: 48px !important;
      height: 48px !important;
      min-height: 48px !important;
      display: inline-grid !important;
      place-items: center !important;
      padding: 0 !important;
      border: 0 !important;
      border-radius: var(--oh-search-radius-control) !important;
      background: var(--oh-search-soft) !important;
      color: var(--oh-search-ink) !important;
      box-sizing: border-box !important;
      touch-action: manipulation !important;
      -webkit-tap-highlight-color: transparent !important;
    }

    .x-events-modal-close-button,
    .x-mot-close,
    .x-mot-cart,
    .x-mot-ai-mode-button.mobile,
    .x-mot-ai-mode-button.tablet {
      position: relative !important;
      line-height: 0 !important;
    }

    .x-events-modal-close-button > *,
    .x-mot-close > *,
    .x-mot-cart > :not(.x-mot-cart__products-count),
    .x-mot-ai-mode-button.mobile > :not(.x-mot-ai-mode-button__title),
    .x-mot-ai-mode-button.tablet > :not(.x-mot-ai-mode-button__title) {
      grid-area: 1 / 1 !important;
      align-self: center !important;
      justify-self: center !important;
      position: static !important;
      inset: auto !important;
      margin: 0 !important;
      transform: none !important;
    }

    .x-mot-cart > .x-mot-cart__icon {
      grid-area: 1 / 1 !important;
      position: static !important;
      inset: auto !important;
      margin: 0 !important;
      transform: none !important;
      place-self: center !important;
    }

    .x-mot-cart > .x-mot-cart__products-count {
      position: absolute !important;
    }

    .x-mot-ai-mode-button.mobile .x-mot-ai-mode-button__title,
    .x-mot-ai-mode-button.tablet .x-mot-ai-mode-button__title {
      display: none !important;
    }

    .x-events-modal-close-button svg,
    .x-mot-close svg,
    .x-mot-cart svg,
    .x-mot-ai-mode-button.mobile svg,
    .x-mot-ai-mode-button.tablet svg {
      display: block !important;
      margin: 0 !important;
      flex: none !important;
    }

    @media (min-width: 600px) and (max-width: 767px) {
      .x-modal.x-mot-main-modal.x-no-query {
        width: 100vw !important;
        max-width: 100vw !important;
        min-width: 0 !important;
        margin-inline: 0 !important;
        box-sizing: border-box !important;
        inset-inline-start: 0 !important;
        inset-inline-end: auto !important;
      }

      .x-modal.x-mot-main-modal.x-no-query > .x-modal__content,
      .x-modal.x-mot-main-modal.x-no-query .x-mot-layout,
      .x-modal.x-mot-main-modal.x-no-query .x-mot-layout__header,
      .x-modal.x-mot-main-modal.x-no-query .x-mot-layout__main,
      .x-modal.x-mot-main-modal.x-no-query .x-mot-layout__main-body,
      .x-modal.x-mot-main-modal.x-no-query .x-mot-layout__main-scroll {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        margin-inline: 0 !important;
        box-sizing: border-box !important;
      }

      .x-modal.x-mot-main-modal.x-no-query .x-mot-layout__header-bottom {
        width: min(calc(100vw - 48px), 672px) !important;
        max-width: 672px !important;
        min-width: 0 !important;
        margin-inline: auto !important;
        box-sizing: border-box !important;
      }

      .x-modal.x-mot-main-modal.x-no-query .x-mot-empathize {
        width: min(calc(100vw - 48px), 672px) !important;
        max-width: 672px !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
      }

      .x-modal.x-mot-main-modal.x-no-query .x-mot-history-queries,
      .x-modal.x-mot-main-modal.x-no-query .x-mot-featured-products {
        width: calc(100% - 40px) !important;
        max-width: calc(100% - 40px) !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
      }
    }

    @media (hover: hover) and (pointer: fine) {
      .x-events-modal-close-button:hover,
      .x-mot-close:hover,
      .x-mot-cart:hover { background: #ececf0 !important; }
    }

    .x-events-modal-close-button:active,
    .x-mot-close:active,
    .x-mot-cart:active { background: var(--oh-search-control-active) !important; }

    .x-mot-close__cross-icon {
      width: 16px !important;
      height: 16px !important;
      color: var(--oh-search-ink) !important;
      stroke: currentColor !important;
    }

    .x-mot-cart__products-count {
      background: var(--oh-search-ink) !important;
      color: #fff !important;
      font-weight: 680 !important;
    }

    .x-mot-search-box__input {
      min-height: 54px !important;
      padding: 0 16px !important;
      border: 1px solid var(--oh-search-hairline) !important;
      border-radius: var(--oh-search-radius-control) !important;
      background: #fafafa !important;
      color: var(--oh-search-ink) !important;
      box-shadow: none !important;
      box-sizing: border-box !important;
      font-size: clamp(18px, 1.4vw, 24px) !important;
      font-weight: 520 !important;
      letter-spacing: -.025em !important;
    }

    .x-mot-search-box__input::placeholder {
      color: #85858a !important;
      opacity: 1 !important;
      font-weight: 520 !important;
    }

    .x-mot-search-box__clear-button {
      min-width: 44px !important;
      min-height: 44px !important;
      border-radius: var(--oh-search-radius-compact) !important;
    }

    .x-mot-ai-mode-button:is(.desktop-s, .desktop-l) {
      width: auto !important;
      min-width: 98px !important;
      height: 54px !important;
      min-height: 54px !important;
      display: inline-flex !important;
      flex-direction: row !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 7px !important;
      padding: 0 14px !important;
      border: 0 !important;
      border-radius: var(--oh-search-radius-control) !important;
      background: var(--oh-search-soft) !important;
      background-image: none !important;
      border-image: none !important;
      box-shadow: none !important;
      color: var(--oh-search-ink) !important;
      white-space: nowrap !important;
      font-size: 12px !important;
      line-height: 1 !important;
    }

    .x-mot-ai-mode-button:is(.desktop-s, .desktop-l)::before,
    .x-mot-ai-mode-button:is(.desktop-s, .desktop-l)::after {
      background-image: none !important;
      border-image: none !important;
      box-shadow: none !important;
    }

    .x-mot-ai-mode-button.mobile,
    .x-mot-ai-mode-button.tablet {
      width: 48px !important;
      min-width: 48px !important;
      height: 48px !important;
      min-height: 48px !important;
      display: inline-grid !important;
      place-items: center !important;
      padding: 0 !important;
      border: 0 !important;
      border-radius: var(--oh-search-radius-control) !important;
      background: var(--oh-search-soft) !important;
      color: var(--oh-search-ink) !important;
      font-size: 0 !important;
    }

    .x-mot-ai-mode-button.mobile :is(svg, .x-mot-ai-mode-button__icon),
    .x-mot-ai-mode-button.tablet :is(svg, .x-mot-ai-mode-button__icon) {
      width: 18px !important;
      min-width: 18px !important;
      height: 18px !important;
      display: block !important;
      color: var(--oh-search-ink) !important;
    }

    .x-mot-ai-mode-button.tablet .x-mot-ai-mode-button__title {
      display: none !important;
    }

    .x-mot-history-queries__title,
    .x-mot-featured-products__title {
      color: var(--oh-search-ink) !important;
      font-size: 15px !important;
      font-weight: 650 !important;
      letter-spacing: -.01em !important;
    }

    .x-mot-history-queries .x-suggestions {
      width: 100% !important;
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      gap: 8px !important;
      padding: 4px 0 8px !important;
      overflow-x: auto !important;
      overscroll-behavior-inline: contain !important;
      scrollbar-width: none !important;
      scroll-snap-type: x proximity !important;
    }

    .x-mot-history-queries .x-suggestions::-webkit-scrollbar { display: none !important; }

    .x-mot-history-queries .x-suggestions__item {
      flex: 0 0 auto !important;
      width: auto !important;
      min-width: 0 !important;
      height: 48px !important;
      scroll-snap-align: start !important;
    }

    .x-mot-history-queries .x-history-query {
      width: auto !important;
      height: 48px !important;
      min-height: 48px !important;
      display: flex !important;
      align-items: center !important;
      border-radius: 999px !important;
      background: var(--oh-search-soft) !important;
      overflow: hidden !important;
    }

    .x-mot-history-queries .x-history-query__suggestion {
      width: auto !important;
      min-width: 0 !important;
      height: 48px !important;
      min-height: 48px !important;
      padding: 0 8px 0 14px !important;
      border-radius: 999px 0 0 999px !important;
      white-space: nowrap !important;
    }

    .x-mot-history-queries .x-history-query__remove {
      width: 44px !important;
      min-width: 44px !important;
      height: 44px !important;
      min-height: 44px !important;
      display: inline-grid !important;
      place-items: center !important;
      border-radius: 50% !important;
    }

    .x-mot-history-queries__actions { gap: 8px !important; }

    .x-clear-history-queries,
    .x-mot-toggle-history-queries {
      min-height: 44px !important;
      padding-inline: 12px !important;
      border-radius: var(--oh-search-radius-compact) !important;
      color: var(--oh-search-muted) !important;
      background: transparent !important;
      font-size: 13px !important;
      font-weight: 600 !important;
      line-height: 1.2 !important;
      font-style: normal !important;
      touch-action: manipulation !important;
    }

    @media (hover: hover) and (pointer: fine) {
      .x-clear-history-queries:hover,
      .x-mot-toggle-history-queries:hover {
        background: var(--oh-search-soft) !important;
        color: var(--oh-search-ink) !important;
      }
    }

    .x-mot-result {
      padding: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      overflow: visible !important;
    }

    .x-mot-result__image-container {
      border: 0 !important;
      border-radius: var(--oh-search-radius-card) !important;
      background: var(--oh-search-soft) !important;
      isolation: isolate !important;
      overflow: hidden !important;
    }

    .x-mot-result__picture { background: var(--oh-search-soft) !important; }

    .x-mot-result__image-container img,
    .x-mot-result__picture img {
      background: transparent !important;
      mix-blend-mode: multiply !important;
      object-fit: contain !important;
    }

    .x-mot-result__details { padding-inline: 4px !important; }

    .x-mot-result__title {
      color: var(--oh-search-ink) !important;
      font-size: 13px !important;
      line-height: 1.35 !important;
      font-weight: 520 !important;
      letter-spacing: -.005em !important;
    }

    .x-mot-result__title-container,
    .x-mot-result-price {
      min-height: 44px !important;
      display: flex !important;
      align-items: center !important;
    }

    .x-mot-result-price { font-weight: 650 !important; }

    .x-mot-main-modal__backdrop-close { display: none !important; }

    .x-mot-open-aside,
    .x-mot-toggle-aside,
    .x-mot-close-aside {
      min-height: 50px !important;
      padding-inline: 16px !important;
      border: 1px solid var(--oh-search-hairline) !important;
      border-radius: var(--oh-search-radius-control) !important;
      background: var(--oh-search-soft) !important;
      color: var(--oh-search-ink) !important;
      touch-action: manipulation !important;
    }

    .x-mot-toggle-aside,
    .x-mot-close-aside {
      height: 52px !important;
      min-height: 52px !important;
      padding-block: 0 !important;
    }

    .x-mot-result-variant-selector:empty,
    .x-mot-result-variant-selector[data-oh-empty-variant="true"] { display: none !important; }

    .x-mot-result__cta {
      min-height: 48px !important;
      margin-block-start: 4px !important;
    }

    .x-mot-result:focus-within .x-mot-result__cta {
      opacity: 1 !important;
      transform: none !important;
    }

    @media (hover: none), (pointer: coarse) {
      .x-mot-result__cta {
        opacity: 1 !important;
        transform: none !important;
      }
    }

    .x-result-add-to-cart {
      min-height: 48px !important;
      padding-inline: 12px !important;
      border: 1px solid var(--oh-search-hairline) !important;
      border-radius: var(--oh-search-radius-compact) !important;
      background: var(--oh-search-soft) !important;
      color: var(--oh-search-ink) !important;
      font-weight: 650 !important;
      touch-action: manipulation !important;
    }

    @media (hover: hover) and (pointer: fine) {
      .x-result-add-to-cart:not(:disabled):not([aria-disabled="true"]):hover {
        background: #ececf0 !important;
      }
    }

    .x-result-add-to-cart:not(:disabled):not([aria-disabled="true"]):active {
      background: var(--oh-search-control-active) !important;
    }

    .x-result-add-to-cart:disabled,
    .x-result-add-to-cart[aria-disabled="true"] {
      border-color: var(--oh-search-hairline) !important;
      background: #fafafa !important;
      color: var(--oh-search-muted) !important;
      opacity: .58 !important;
      cursor: not-allowed !important;
    }

    .x-result-add-to-cart[aria-busy="true"] { cursor: progress !important; }

    .x-recommendations {
      gap: 18px !important;
      scroll-snap-type: x proximity !important;
    }

    .x-recommendations__item { scroll-snap-align: start !important; }

    .x-no-query[data-oh-motive-blank-fallback="true"] {
      min-height: min(52vh, 420px) !important;
      display: grid !important;
      place-items: start center !important;
      padding: clamp(38px, 8vh, 88px) 20px !important;
      box-sizing: border-box !important;
    }

    .x-no-query[data-oh-motive-blank-fallback="true"]::before {
      content: attr(data-oh-motive-blank-label);
      max-width: 440px;
      padding: 18px 22px;
      border: 1px solid var(--oh-search-hairline);
      border-radius: var(--oh-search-radius-card);
      background: var(--oh-search-soft);
      color: var(--oh-search-muted);
      font-size: clamp(15px, 1.2vw, 18px);
      font-weight: 560;
      line-height: 1.4;
      letter-spacing: -.01em;
      text-align: center;
      box-sizing: border-box;
    }

    .x-mot-search-box__input:focus,
    .x-mot-search-box__input:focus-visible {
      border-color: transparent !important;
      outline: 2px solid rgba(29, 29, 31, .68) !important;
      outline-offset: -2px !important;
      box-shadow: none !important;
    }

    :is(button, a, input):focus-visible {
      outline: 2px solid rgba(29, 29, 31, .7) !important;
      outline-offset: 2px !important;
    }

    @media (max-width: 699px) {
      .x-mot-brand-logo__image { max-width: 108px !important; }
      .x-mot-search-box__input { min-height: 50px !important; font-size: 18px !important; }
      .x-mot-result__image-container { border-radius: var(--oh-search-radius-card) !important; }
      .x-recommendations { gap: 12px !important; }
      .x-mot-history-queries .x-suggestions { padding-inline: 0 !important; }
    }

    @media (max-height: 540px) and (orientation: landscape) {
      .x-mot-layout__header {
        height: 128px !important;
        min-height: 128px !important;
        padding-block: 4px !important;
      }
      .x-mot-layout__header-middle {
        height: 120px !important;
        min-height: 120px !important;
        padding-block: 40px 8px !important;
        box-sizing: border-box !important;
      }
      .x-mot-layout__header-start,
      .x-mot-layout__header-end {
        height: 116px !important;
        min-height: 116px !important;
        margin-block-start: 8px !important;
        box-sizing: border-box !important;
      }
      .x-mot-history-queries { margin-block: 8px !important; }
      .x-mot-history-queries__title { margin-block-end: 4px !important; }
    }

    @media (forced-colors: active) {
      .x-mot-search-box__input,
      .x-events-modal-close-button,
      .x-mot-close,
      .x-mot-cart,
      .x-mot-open-aside,
      .x-mot-toggle-aside,
      .x-mot-close-aside,
      .x-result-add-to-cart,
      .x-mot-result__image-container {
        border: 1px solid CanvasText !important;
      }
      :is(button, a, input):focus-visible { outline-color: Highlight !important; }
      .x-mot-search-box__input:focus-visible {
        outline-color: Highlight !important;
        border-color: Canvas !important;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      *, *::before, *::after {
        scroll-behavior: auto !important;
        transition-duration: .01ms !important;
        animation-duration: .01ms !important;
        animation-iteration-count: 1 !important;
      }
    }
  `;

  const SUPPORT_HANDLES = new Set([
    'ayuda', 'preguntas-frecuentes', 'contacto', 'envios-y-precios',
    'devoluciones-y-reembolsos', 'pago-seguro', 'garantias',
    'guia-de-compra', 'configurar-lentes', 'indice-de-las-lentes',
    'materiales-y-tratamientos-de-las-lentes',
    'como-leer-su-prescripcion-de-lentes', 'guia-cuidado-lentillas',
    'glosario-optico', 'conocenos', 'equipo-profesional',
    'comprometidos-con-la-autenticidad-su-guia-contra-las-falsificaciones',
    'ofertas-y-promociones', 'oferta-2x1-en-cristales-graduados',
    'aviso-legal', 'politica-de-privacidad', 'cookies',
    'data-sharing-opt-out', 'sitemap', 'enlaces-de-interes',
    'comprobar-disponibilidad', 'shipping-protection-terms'
  ]);

  const LEGAL_HANDLES = new Set([
    'aviso-legal', 'politica-de-privacidad', 'cookies', 'garantias',
    'data-sharing-opt-out', 'shipping-protection-terms'
  ]);

  const GUIDE_HANDLES = new Set([
    'configurar-lentes', 'indice-de-las-lentes',
    'materiales-y-tratamientos-de-las-lentes',
    'como-leer-su-prescripcion-de-lentes', 'guia-cuidado-lentillas',
    'glosario-optico', 'oferta-2x1-en-cristales-graduados'
  ]);

  function currentPageHandle() {
    const parts = window.location.pathname.split('/').filter(Boolean);
    return parts[0] === 'pages' ? (parts[1] || '') : '';
  }

  function applySupportClasses() {
    if (!document.body) return;
    const handle = currentPageHandle();
    const isSupport = SUPPORT_HANDLES.has(handle);
    document.body.classList.toggle('oh-support-page', isSupport);
    if (!isSupport) return;

    document.body.classList.toggle('oh-support-hub', handle === 'ayuda');
    document.body.classList.toggle('oh-support-legal', LEGAL_HANDLES.has(handle));
    document.body.classList.toggle('oh-support-guide', GUIDE_HANDLES.has(handle));
    document.body.classList.toggle('oh-support-contact',
      handle === 'contacto' || handle === 'comprobar-disponibilidad');
    document.body.classList.toggle('oh-support-sitemap',
      handle === 'sitemap' || handle === 'enlaces-de-interes');
    document.body.classList.toggle('oh-support-classic',
      !LEGAL_HANDLES.has(handle) && !GUIDE_HANDLES.has(handle) &&
      handle !== 'ayuda' && handle !== 'contacto' && handle !== 'sitemap');
  }

  function improveSupportSemantics() {
    if (!document.body?.classList.contains('oh-support-page')) return;

    document.querySelectorAll('a[target="_blank"]').forEach((link) => {
      const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      rel.add('noreferrer');
      link.setAttribute('rel', [...rel].join(' '));
    });

    document.querySelectorAll('.oh-help-stats').forEach((group) => {
      const count = group.querySelectorAll(':scope > .oh-help-stat').length;
      group.removeAttribute('data-oh-help-stats-count');
      if (count) group.setAttribute('data-oh-help-stat-count', String(count));
      else group.removeAttribute('data-oh-help-stat-count');
    });

    document.querySelectorAll('.oh-help-nav').forEach((nav) => {
      nav.setAttribute('role', 'navigation');
      if (!nav.getAttribute('aria-label')) nav.setAttribute('aria-label', 'Secciones de ayuda');
      nav.querySelectorAll('a[href]').forEach((link) => {
        try {
          const path = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
          const current = window.location.pathname.replace(/\/$/, '');
          if (path === current) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        } catch (_) { /* Ignore malformed legacy URLs; deployment audit patches them. */ }
      });
    });
  }

  function hydrateCountryPopover(popover) {
    if (!popover || popover.dataset.ohCountryHydrated === 'true') return;
    const target = popover.querySelector('[data-country-list-target]');
    const template = popover.querySelector('template[data-country-list-template]');
    if (!target || !template) return;
    if (!target.childElementCount) target.append(template.content.cloneNode(true));
    popover.dataset.ohCountryHydrated = 'true';
    popover.removeAttribute('data-deferred-country-list');
  }

  function normaliseLocaleText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase();
  }

  function decorateLocaleOption(option, isCountry) {
    if (option.dataset.ohLocaleDecorated === 'true') return;
    const source = option.textContent.trim();
    option.dataset.ohLocaleSearch = normaliseLocaleText(source);

    if (isCountry) {
      const match = source.match(/^(.*)\s+\(([^()]*)\)$/);
      if (match) {
        const name = document.createElement('span');
        const currency = document.createElement('span');
        name.className = 'oh-locale-name';
        currency.className = 'oh-locale-currency';
        name.textContent = match[1];
        currency.textContent = match[2];
        option.replaceChildren(name, currency);
      }
    }

    option.dataset.ohLocaleDecorated = 'true';
  }

  function enhanceLocalizationPopover(popover) {
    if (!popover || !popover.closest('.footer')) return;
    const list = popover.querySelector('.popover__value-list');
    const options = list ? [...list.querySelectorAll('.popover__value-option')] : [];
    if (!list || !options.length) return;

    const isCountry = popover.id.includes('country');
    const header = popover.querySelector('[slot="header"]');
    if (header) header.textContent = isCountry ? 'País y moneda' : 'Idioma';
    popover.setAttribute(
      'aria-label',
      isCountry ? 'Seleccionar país y moneda' : 'Seleccionar idioma'
    );

    if (popover.dataset.ohLocaleEnhanced !== 'true') {
      if (!list.id) list.id = `${popover.id}-options`;
      options.forEach((option) => decorateLocaleOption(option, isCountry));

      if (isCountry) {
        const search = document.createElement('div');
        const label = document.createElement('label');
        const input = document.createElement('input');
        const status = document.createElement('span');
        const empty = document.createElement('p');
        const inputId = `${popover.id}-search`;
        const statusId = `${popover.id}-status`;

        search.className = 'oh-locale-search';
        label.className = 'sr-only';
        label.htmlFor = inputId;
        label.textContent = 'Buscar país o moneda';
        input.className = 'oh-locale-search__field';
        input.id = inputId;
        input.type = 'search';
        input.inputMode = 'search';
        input.autocomplete = 'off';
        input.spellcheck = false;
        input.placeholder = 'Buscar país o moneda';
        input.setAttribute('aria-controls', list.id);
        input.setAttribute('aria-describedby', statusId);
        status.className = 'sr-only';
        status.id = statusId;
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        empty.className = 'oh-locale-empty';
        empty.hidden = true;
        empty.textContent = 'No hay coincidencias.';

        const filterOptions = () => {
          const query = normaliseLocaleText(input.value.trim());
          let visible = 0;
          options.forEach((option) => {
            const match = !query || option.dataset.ohLocaleSearch.includes(query);
            option.hidden = !match;
            option.setAttribute('aria-hidden', String(!match));
            if (match) visible += 1;
          });
          empty.hidden = visible !== 0;
          status.textContent = visible === 1
            ? '1 opción disponible'
            : `${visible} opciones disponibles`;
        };

        input.addEventListener('input', filterOptions);
        input.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowDown') return;
          const first = options.find((option) => !option.hidden);
          if (!first) return;
          event.preventDefault();
          first.focus();
        });
        search.append(label, input, status);
        const form = list.closest('form');
        (form || list).before(search);
        (form || list).after(empty);
        filterOptions();
      }

      popover.dataset.ohLocaleEnhanced = 'true';
    }

    const input = popover.querySelector('.oh-locale-search__field');
    if (popover.hasAttribute('open') && input && popover.dataset.ohLocaleFocus !== 'true') {
      popover.dataset.ohLocaleFocus = 'true';
      window.requestAnimationFrame(() => input.focus({ preventScroll: true }));
    } else if (!popover.hasAttribute('open')) {
      delete popover.dataset.ohLocaleFocus;
    }
  }

  function hydrateFromTrigger(target) {
    const trigger = target?.closest?.('[aria-controls]');
    if (!trigger) return;
    const id = trigger.getAttribute('aria-controls');
    if (!id) return;
    const popover = document.getElementById(id);
    if (popover?.querySelector('template[data-country-list-template]')) {
      hydrateCountryPopover(popover);
    }
  }


  // OH_MOTIVE_SEMANTICS_V8
  function enhanceMotiveSemantics(root) {
    if (!root || root.__ohMotiveEnhancingV8) return;
    root.__ohMotiveEnhancingV8 = true;
    try {
      const language = (document.documentElement.lang || 'es').toLowerCase().split('-')[0];
      const dictionaries = {
        es: { search: 'Búsqueda', home: 'OpticalH · Inicio', cart: 'Carrito', ai: 'Modo IA', remove: 'Eliminar búsqueda reciente', close: 'Cerrar búsqueda', filters: 'Orden y filtros', closeFilters: 'Cerrar filtros', blank: 'Busca por marca, modelo o referencia' },
        en: { search: 'Search', home: 'OpticalH · Home', cart: 'Cart', ai: 'AI mode', remove: 'Remove recent search', close: 'Close search', filters: 'Sort and filters', closeFilters: 'Close filters', blank: 'Search by brand, model or reference' },
        fr: { search: 'Recherche', home: 'OpticalH · Accueil', cart: 'Panier', ai: 'Mode IA', remove: 'Supprimer la recherche récente', close: 'Fermer la recherche', filters: 'Tri et filtres', closeFilters: 'Fermer les filtres', blank: 'Recherchez par marque, modèle ou référence' },
        de: { search: 'Suche', home: 'OpticalH · Startseite', cart: 'Warenkorb', ai: 'KI-Modus', remove: 'Letzte Suche entfernen', close: 'Suche schließen', filters: 'Sortierung und Filter', closeFilters: 'Filter schließen', blank: 'Suche nach Marke, Modell oder Artikelnummer' },
        it: { search: 'Ricerca', home: 'OpticalH · Home', cart: 'Carrello', ai: 'Modalità IA', remove: 'Rimuovi ricerca recente', close: 'Chiudi ricerca', filters: 'Ordina e filtra', closeFilters: 'Chiudi filtri', blank: 'Cerca per marca, modello o codice' },
        pt: { search: 'Pesquisa', home: 'OpticalH · Início', cart: 'Carrinho', ai: 'Modo IA', remove: 'Remover pesquisa recente', close: 'Fechar pesquisa', filters: 'Ordenar e filtrar', closeFilters: 'Fechar filtros', blank: 'Pesquise por marca, modelo ou referência' },
        ru: { search: 'Поиск', home: 'OpticalH · Главная', cart: 'Корзина', ai: 'Режим ИИ', remove: 'Удалить недавний запрос', close: 'Закрыть поиск', filters: 'Сортировка и фильтры', closeFilters: 'Закрыть фильтры', blank: 'Ищите по бренду, модели или артикулу' },
        zh: { search: '搜索', home: 'OpticalH · 首页', cart: '购物车', ai: 'AI 模式', remove: '删除最近搜索', close: '关闭搜索', filters: '排序和筛选', closeFilters: '关闭筛选', blank: '按品牌、型号或编号搜索' }
      };
      const labels = dictionaries[language] || dictionaries.en;
      const setAttributeIfChanged = (element, name, value) => {
        if (element && element.getAttribute(name) !== value) element.setAttribute(name, value);
      };
      const removeAttributeIfPresent = (element, name) => {
        if (element?.hasAttribute(name)) element.removeAttribute(name);
      };
      const isVisible = (element) => {
        if (!element?.isConnected) return false;
        const box = element.getBoundingClientRect();
        const style = getComputedStyle(element);
        return box.width > 0
          && box.height > 0
          && box.right > 0
          && box.bottom > 0
          && box.left < window.innerWidth
          && box.top < window.innerHeight
          && style.display !== 'none'
          && style.visibility !== 'hidden';
      };
      const setOwnedLabel = (element, label, owner, replaceGeneric = false) => {
        if (!element || !label) return;
        const current = (element.getAttribute('aria-label') || '').trim();
        const owned = element.dataset.ohMotiveLabelOwner === owner;
        const generic = replaceGeneric && /^base modal content$/i.test(current);
        if (!current || owned || generic) {
          setAttributeIfChanged(element, 'aria-label', label);
          if (element.dataset.ohMotiveLabelOwner !== owner) element.dataset.ohMotiveLabelOwner = owner;
        }
      };
      const ensureUniqueId = (element, base) => {
        if (!element) return '';
        const occupiedIds = new Set(Array.from(root.querySelectorAll('[id]'))
          .filter((candidate) => candidate !== element)
          .map((candidate) => candidate.id));
        let value = element.id || base;
        let suffix = 2;
        while (occupiedIds.has(value)) {
          value = `${base}-${suffix}`;
          suffix += 1;
        }
        if (element.id !== value) element.id = value;
        return value;
      };

      const input = root.querySelector('input[aria-label="Caja de búsqueda"], .x-mot-search-box__input, input[type="search"]');
      const dialogs = Array.from(root.querySelectorAll('[role="dialog"]'));
      const mainDialog = dialogs.find((dialog) => !dialog.closest('.x-mot-layout__aside')) || null;
      const filterPanel = root.querySelector('.x-mot-layout__aside');
      const nestedFilterDialog = filterPanel?.matches('[role="dialog"]')
        ? filterPanel
        : filterPanel?.querySelector('[role="dialog"]');
      const filterLayer = nestedFilterDialog
        || (filterPanel?.childElementCount ? filterPanel : null);
      const desktopFilterPanel = root.querySelector('.x-mot-layout__main-aside');
      const filterOpen = Boolean(filterLayer && isVisible(filterLayer));
      const desktopFilterOpen = Boolean(desktopFilterPanel && isVisible(desktopFilterPanel));

      if (mainDialog) {
        setAttributeIfChanged(mainDialog, 'aria-modal', 'true');
        if (!mainDialog.hasAttribute('aria-labelledby')) setOwnedLabel(mainDialog, labels.search, 'main-dialog', true);
      }
      if (filterLayer) {
        if (filterLayer === filterPanel) setAttributeIfChanged(filterLayer, 'role', 'dialog');
        if (filterOpen) {
          removeAttributeIfPresent(filterLayer, 'aria-hidden');
          removeAttributeIfPresent(filterLayer, 'inert');
          setAttributeIfChanged(filterLayer, 'aria-modal', 'true');
          if (!filterLayer.hasAttribute('aria-labelledby')) setOwnedLabel(filterLayer, labels.filters, 'filter-dialog', true);
        } else {
          setAttributeIfChanged(filterLayer, 'aria-hidden', 'true');
          setAttributeIfChanged(filterLayer, 'inert', '');
          removeAttributeIfPresent(filterLayer, 'aria-modal');
        }
      }

      const logo = root.querySelector('.x-mot-brand-logo');
      setOwnedLabel(logo, labels.home, 'home');
      const cart = root.querySelector('.x-mot-cart');
      const cartCount = root.querySelector('.x-mot-cart__products-count')?.textContent?.trim();
      setOwnedLabel(cart, cartCount ? `${labels.cart} · ${cartCount}` : labels.cart, 'cart');
      root.querySelectorAll('.x-mot-ai-mode-button').forEach((button) => {
        setOwnedLabel(button, labels.ai, 'ai');
        if (!button.title || button.dataset.ohMotiveTitleOwner === 'ai') {
          if (button.title !== labels.ai) button.title = labels.ai;
          if (button.dataset.ohMotiveTitleOwner !== 'ai') button.dataset.ohMotiveTitleOwner = 'ai';
        }
      });
      root.querySelectorAll('.x-mot-close').forEach((button) => setOwnedLabel(button, labels.close, 'main-close'));
      root.querySelectorAll('.x-mot-main-modal__backdrop-close').forEach((button) => {
        setAttributeIfChanged(button, 'aria-hidden', 'true');
        if (button.tabIndex !== -1) button.tabIndex = -1;
      });

      const mobilePanelId = filterPanel ? ensureUniqueId(filterPanel, 'oh-motive-filter-panel') : '';
      root.querySelectorAll('.x-mot-open-aside').forEach((button) => {
        setOwnedLabel(button, labels.filters, 'open-filters');
        setAttributeIfChanged(button, 'aria-expanded', String(filterOpen));
        if (mobilePanelId) setAttributeIfChanged(button, 'aria-controls', mobilePanelId);
      });
      root.querySelectorAll('.x-mot-close-aside').forEach((button) => setOwnedLabel(button, labels.closeFilters, 'close-filters'));
      const desktopPanelId = desktopFilterPanel
        ? ensureUniqueId(desktopFilterPanel, 'oh-motive-desktop-filter-panel')
        : mobilePanelId;
      root.querySelectorAll('.x-mot-toggle-aside').forEach((button) => {
        const text = button.textContent?.trim() || labels.filters;
        setOwnedLabel(button, text, 'toggle-filters');
        setAttributeIfChanged(button, 'aria-expanded', String(desktopFilterOpen || filterOpen));
        if (desktopPanelId) setAttributeIfChanged(button, 'aria-controls', desktopPanelId);
      });

      root.querySelectorAll('.x-mot-history-queries__title, .x-mot-featured-products__title').forEach((heading) => {
        setAttributeIfChanged(heading, 'role', 'heading');
        setAttributeIfChanged(heading, 'aria-level', '2');
      });

      root.querySelectorAll('.x-mot-result').forEach((card) => {
        const titleNode = card.querySelector('.x-mot-result__title');
        const title = card.getAttribute('data-wysiwyg-title') || titleNode?.textContent?.trim();
        const nativeHeading = titleNode?.matches?.('h1, h2, h3, h4, h5, h6')
          ? titleNode
          : titleNode?.querySelector?.('h1, h2, h3, h4, h5, h6');
        if (nativeHeading) {
          let semanticHeading = Array.from(nativeHeading.children).find(
            (child) => child.dataset?.ohMotiveResultHeading === 'true'
          ) || null;
          if (!semanticHeading) {
            semanticHeading = document.createElement('span');
            semanticHeading.dataset.ohMotiveResultHeading = 'true';
            while (nativeHeading.firstChild) semanticHeading.append(nativeHeading.firstChild);
            nativeHeading.append(semanticHeading);
          } else {
            Array.from(nativeHeading.childNodes)
              .filter((child) => child !== semanticHeading)
              .forEach((child) => semanticHeading.append(child));
          }
          setAttributeIfChanged(nativeHeading, 'role', 'presentation');
          removeAttributeIfPresent(nativeHeading, 'aria-level');
          setAttributeIfChanged(semanticHeading, 'role', 'heading');
          setAttributeIfChanged(semanticHeading, 'aria-level', '3');
        } else if (titleNode) {
          setAttributeIfChanged(titleNode, 'role', 'heading');
          setAttributeIfChanged(titleNode, 'aria-level', '3');
        }
        const imageLink = card.querySelector('.x-mot-result__image-container');
        if (imageLink && title) setOwnedLabel(imageLink, title, 'result-image');
        const add = card.querySelector('.x-result-add-to-cart');
        const action = add?.textContent?.trim();
        if (add && action && title) setOwnedLabel(add, `${action}: ${title}`, 'result-add');
        const variantSelector = card.querySelector('.x-mot-result-variant-selector');
        if (variantSelector) {
          const hasControl = variantSelector.querySelector('input, select, button, [role="option"]');
          const empty = !hasControl && !variantSelector.textContent.trim();
          if (empty) {
            if (variantSelector.dataset.ohEmptyVariant !== 'true') variantSelector.dataset.ohEmptyVariant = 'true';
            if (!variantSelector.hidden) variantSelector.hidden = true;
          } else if (variantSelector.dataset.ohEmptyVariant === 'true') {
            delete variantSelector.dataset.ohEmptyVariant;
            if (variantSelector.hidden) variantSelector.hidden = false;
          }
        }
      });
      root.querySelectorAll('.x-history-query__remove').forEach((button) => {
        const query = button.closest('.x-history-query')?.querySelector('.x-history-query__suggestion')?.textContent?.trim();
        setOwnedLabel(button, query ? `${labels.remove}: ${query}` : labels.remove, 'history-remove');
      });

      const visibleHeaderSearchTrigger = () => {
        const candidates = [];
        document.querySelectorAll(
          'header .header__search-link, header [aria-controls="search-drawer"]'
        ).forEach((element) => {
          if (element.matches('a, button')) candidates.push(element);
          candidates.push(...element.querySelectorAll('a, button'));
        });
        const semanticFallbacks = Array.from(document.querySelectorAll(
          'header a[href="javascript:void(0)"], header button[aria-label], header a[aria-label]'
        )).filter((element) => /buscar|search|recherche|suche|ricerca|pesquisa|поиск|搜索/i.test(
          `${element.getAttribute('aria-label') || ''} ${element.textContent || ''}`
        ));
        return [...new Set([...candidates, ...semanticFallbacks])].find(isVisible) || null;
      };
      if (!root.__ohMotiveReturnTargetV8
        || !root.__ohMotiveReturnTargetV8.isConnected
        || !isVisible(root.__ohMotiveReturnTargetV8)) {
        root.__ohMotiveReturnTargetV8 = visibleHeaderSearchTrigger();
      }

      const liveMotiveLayers = () => {
        const liveDialogs = Array.from(root.querySelectorAll('[role="dialog"]'));
        const liveFilterPanel = root.querySelector('.x-mot-layout__aside');
        const liveNestedFilter = liveFilterPanel?.matches('[role="dialog"]')
          ? liveFilterPanel
          : liveFilterPanel?.querySelector('[role="dialog"]');
        return {
          main: liveDialogs.find((dialog) => !dialog.closest('.x-mot-layout__aside')) || null,
          filter: liveNestedFilter || (liveFilterPanel?.childElementCount ? liveFilterPanel : null),
          desktopFilter: root.querySelector('.x-mot-layout__main-aside')
        };
      };
      const focusableMotiveControls = (scope) => Array.from(scope?.querySelectorAll?.(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ) || []).filter((element) => element.tabIndex >= 0
        && element.getAttribute('aria-disabled') !== 'true'
        && isVisible(element)
        && !element.closest('[inert], [aria-hidden="true"]'));

      const returnMainFocus = () => {
        const generation = (root.__ohMotiveMainFocusGenerationV8 || 0) + 1;
        root.__ohMotiveMainFocusGenerationV8 = generation;
        let frames = 0;
        let closedFrames = 0;
        const resolveTarget = () => {
          const stored = root.__ohMotiveReturnTargetV8;
          return stored?.isConnected && isVisible(stored) ? stored : visibleHeaderSearchTrigger();
        };
        const activeIsUnowned = () => {
          const active = document.activeElement;
          return !active || active === document.body || active === document.documentElement || active === root.host;
        };
        const stabilize = (target) => {
          if (root.__ohMotiveMainFocusGenerationV8 !== generation) return;
          if (!target?.isConnected || !isVisible(target)) return;
          target.focus({ preventScroll: true });
          const checkpoints = [80, 240, 520];
          checkpoints.forEach((checkpoint) => {
            window.setTimeout(() => {
              if (root.__ohMotiveMainFocusGenerationV8 !== generation) return;
              const liveMain = liveMotiveLayers().main;
              if (liveMain && isVisible(liveMain)) return;
              const currentTarget = resolveTarget();
              if (!currentTarget?.isConnected || !isVisible(currentTarget)) return;
              if (document.activeElement === currentTarget || currentTarget.contains(document.activeElement)) return;
              if (activeIsUnowned()) currentTarget.focus({ preventScroll: true });
            }, checkpoint);
          });
        };
        const waitForClose = () => {
          if (root.__ohMotiveMainFocusGenerationV8 !== generation) return;
          frames += 1;
          const liveMain = liveMotiveLayers().main;
          if (liveMain && isVisible(liveMain)) {
            closedFrames = 0;
            if (frames < 120) window.requestAnimationFrame(waitForClose);
            return;
          }
          closedFrames += 1;
          if (closedFrames < 4) {
            window.requestAnimationFrame(waitForClose);
            return;
          }
          stabilize(resolveTarget());
        };
        window.requestAnimationFrame(waitForClose);
      };
      const returnFilterFocus = () => {
        const target = root.__ohMotiveFilterReturnTargetV8;
        if (!target?.isConnected) return;
        let frames = 0;
        const waitForClose = () => {
          frames += 1;
          const liveFilter = liveMotiveLayers().filter;
          if (liveFilter && isVisible(liveFilter) && frames < 30) {
            window.requestAnimationFrame(waitForClose);
            return;
          }
          if (isVisible(target)) target.focus({ preventScroll: true });
        };
        window.requestAnimationFrame(waitForClose);
      };
      const trapMotiveTab = (event) => {
        const layers = liveMotiveLayers();
        const filterIsModal = layers.filter
          && layers.filter.getAttribute('aria-modal') === 'true'
          && isVisible(layers.filter);
        const scope = filterIsModal ? layers.filter : layers.main;
        if (!scope || scope.getAttribute('aria-modal') !== 'true' || !isVisible(scope)) return false;
        const controls = focusableMotiveControls(scope);
        if (!controls.length) return false;
        const first = controls[0];
        const last = controls[controls.length - 1];
        const active = root.activeElement;
        const outside = !active || !scope.contains(active);
        const wrapBackward = event.shiftKey && active === first;
        const wrapForward = !event.shiftKey && active === last;
        if (!outside && !wrapBackward && !wrapForward) return false;
        event.preventDefault();
        event.stopImmediatePropagation();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
        return true;
      };
      const handleMotiveKeydown = (event) => {
        if (event.key === 'Tab') {
          trapMotiveTab(event);
          return;
        }
        if (event.key !== 'Escape') return;
        const layers = liveMotiveLayers();
        const closeAside = root.querySelector('.x-mot-close-aside');
        if (closeAside && layers.filter && isVisible(layers.filter)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          closeAside.click();
          return;
        }
        const desktopToggle = root.querySelector('.x-mot-toggle-aside[aria-expanded="true"]');
        if (desktopToggle && layers.desktopFilter && isVisible(layers.desktopFilter)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          desktopToggle.click();
          return;
        }
        const close = root.querySelector('.x-mot-close');
        if (!close || !layers.main || !isVisible(layers.main)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        close.click();
      };
      const syncInitialFocus = () => {
        const liveMain = liveMotiveLayers().main;
        const visible = Boolean(liveMain && isVisible(liveMain));
        if (!visible) {
          root.__ohMotiveDialogWasVisibleV8 = false;
          if (root.__ohMotiveFocusTimerV8) {
            window.clearTimeout(root.__ohMotiveFocusTimerV8);
            root.__ohMotiveFocusTimerV8 = 0;
          }
          return;
        }
        if (root.__ohMotiveDialogWasVisibleV8) return;
        root.__ohMotiveDialogWasVisibleV8 = true;
        root.__ohMotiveMainFocusGenerationV8 = (root.__ohMotiveMainFocusGenerationV8 || 0) + 1;
        const activeBeforeOpen = document.activeElement;
        const activeSearchTrigger = activeBeforeOpen?.closest?.(
          'header .header__search-link a, header .header__search-link button, header [aria-controls="search-drawer"]'
        );
        const nextReturnTarget = activeSearchTrigger && isVisible(activeSearchTrigger)
          ? activeSearchTrigger
          : visibleHeaderSearchTrigger();
        if (nextReturnTarget) root.__ohMotiveReturnTargetV8 = nextReturnTarget;
        let attempts = 0;
        const probe = () => {
          root.__ohMotiveFocusTimerV8 = 0;
          attempts += 1;
          const currentMain = liveMotiveLayers().main;
          const liveInput = currentMain?.querySelector(
            'input[aria-label="Caja de búsqueda"], .x-mot-search-box__input, input[type="search"]'
          );
          if (!currentMain || !isVisible(currentMain)) return;
          if (!liveInput || !isVisible(liveInput)) {
            if (attempts < 12) root.__ohMotiveFocusTimerV8 = window.setTimeout(probe, 50);
            return;
          }
          const active = root.activeElement;
          if (!active || active === root.host || !currentMain.contains(active)) liveInput.focus({ preventScroll: true });
        };
        root.__ohMotiveFocusTimerV8 = window.setTimeout(probe, 0);
      };
      const clearBlankFallback = () => {
        if (root.__ohMotiveBlankTimerV8) {
          window.clearTimeout(root.__ohMotiveBlankTimerV8);
          root.__ohMotiveBlankTimerV8 = 0;
        }
        root.querySelectorAll('.x-no-query[data-oh-motive-blank-fallback]').forEach((container) => {
          removeAttributeIfPresent(container, 'data-oh-motive-blank-fallback');
          removeAttributeIfPresent(container, 'data-oh-motive-blank-label');
        });
      };
      const blankFallbackEligible = () => {
        const liveMain = liveMotiveLayers().main;
        const noQuery = root.querySelector('.x-no-query');
        const liveInput = root.querySelector(
          'input[aria-label="Caja de búsqueda"], .x-mot-search-box__input, input[type="search"]'
        );
        const hasNativeContent = Boolean(root.querySelector(
          '.x-mot-history-queries, .x-mot-featured-products, .x-mot-result, .x-recommendations__item'
        ));
        const noQueryStyle = noQuery ? getComputedStyle(noQuery) : null;
        return Boolean(liveMain && isVisible(liveMain)
          && noQuery?.isConnected
          && noQueryStyle?.display !== 'none'
          && noQueryStyle?.visibility !== 'hidden'
          && liveInput && isVisible(liveInput)
          && !liveInput.value.trim()
          && !hasNativeContent);
      };
      const syncBlankFallback = () => {
        if (!blankFallbackEligible()) {
          clearBlankFallback();
          return;
        }
        if (root.__ohMotiveBlankTimerV8
          || root.querySelector('.x-no-query[data-oh-motive-blank-fallback="true"]')) return;
        root.__ohMotiveBlankTimerV8 = window.setTimeout(() => {
          root.__ohMotiveBlankTimerV8 = 0;
          if (!blankFallbackEligible()) return;
          const noQuery = root.querySelector('.x-no-query');
          setAttributeIfChanged(noQuery, 'data-oh-motive-blank-fallback', 'true');
          setAttributeIfChanged(noQuery, 'data-oh-motive-blank-label', labels.blank);
        }, 600);
      };

      root.__ohMotiveHandleKeydownV8 = handleMotiveKeydown;
      root.__ohMotiveReturnMainFocusV8 = returnMainFocus;
      root.__ohMotiveReturnFilterFocusV8 = returnFilterFocus;
      root.__ohMotiveSyncBlankV8 = syncBlankFallback;
      if (!window.__ohMotiveViewportBoundV8) {
        window.__ohMotiveViewportBoundV8 = true;
        let viewportFrame = 0;
        const syncViewport = () => {
          if (viewportFrame) return;
          viewportFrame = window.requestAnimationFrame(() => {
            viewportFrame = 0;
            applyMotiveStyles();
          });
        };
        window.addEventListener('resize', syncViewport, { passive: true });
        window.addEventListener('orientationchange', syncViewport, { passive: true });
      }
      if (!root.__ohMotiveEventsBoundV8) {
        root.__ohMotiveEventsBoundV8 = true;
        root.addEventListener('keydown', (event) => root.__ohMotiveHandleKeydownV8?.(event), true);
        root.addEventListener('click', (event) => {
          const openAside = event.target.closest?.('.x-mot-open-aside');
          if (openAside) root.__ohMotiveFilterReturnTargetV8 = openAside;
          if (event.target.closest?.('.x-mot-close-aside')) root.__ohMotiveReturnFilterFocusV8?.();
          if (event.target.closest?.('.x-mot-close')) root.__ohMotiveReturnMainFocusV8?.();

          // OH_MOTIVE_FILTER_SHOW_RESULTS_FALLBACK_V9
          const showResults = event.target.closest?.(
            '.x-events-modal-id-close-button.x-mot-selected-filters__show-results-button'
          );
          if (showResults) {
            const generation = (root.__ohMotiveShowResultsGenerationV9 || 0) + 1;
            root.__ohMotiveShowResultsGenerationV9 = generation;
            window.setTimeout(() => {
              if (root.__ohMotiveShowResultsGenerationV9 !== generation) return;
              const liveFilter = liveMotiveLayers().filter;
              if (!liveFilter || !isVisible(liveFilter)) return;
              const closeAside = root.querySelector('.x-mot-close-aside');
              if (!closeAside?.isConnected) return;
              root.__ohMotiveShowResultsFallbackActiveV9 = true;
              try {
                closeAside.click();
              } finally {
                root.__ohMotiveShowResultsFallbackActiveV9 = false;
              }
              window.requestAnimationFrame(() => applyMotiveStyles());
              window.setTimeout(() => applyMotiveStyles(), 100);
            }, 180);
          }

          if (event.target.closest?.('.x-mot-open-aside, .x-mot-toggle-aside, .x-mot-close-aside')) {
            window.requestAnimationFrame(() => applyMotiveStyles());
            window.setTimeout(() => applyMotiveStyles(), 100);
          }
        }, true);
        root.addEventListener('input', () => {
          root.__ohMotiveSyncBlankV8?.();
          window.requestAnimationFrame(() => applyMotiveStyles());
        });
      }
      syncInitialFocus();
      syncBlankFallback();

      if (!root.__ohMotiveSemanticObserverV8) {
        let semanticFrame = 0;
        root.__ohMotiveSemanticObserverV8 = new MutationObserver(() => {
          if (semanticFrame) return;
          semanticFrame = window.requestAnimationFrame(() => {
            semanticFrame = 0;
            applyMotiveStyles();
          });
        });
        root.__ohMotiveSemanticObserverV8.observe(root, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['aria-busy', 'aria-disabled', 'disabled', 'class', 'style']
        });
      }
      if (input && !input.hasAttribute('autocomplete')) input.setAttribute('autocomplete', 'off');
    } finally {
      root.__ohMotiveEnhancingV8 = false;
    }
  }

  function applyMotiveStyles() {
    const root = document.querySelector('#motive-container')?.shadowRoot;
    if (!root) return false;
    let style = root.getElementById(MOTIVE_STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = MOTIVE_STYLE_ID;
      root.append(style);
    }
    if (style.textContent !== MOTIVE_CSS) style.textContent = MOTIVE_CSS;
    enhanceMotiveSemantics(root);
    return true;
  }

  function compactMenuDrawerLocaleLabels() {
    document.querySelectorAll(
      'header-menu-drawer .menu-drawer__footer-item button[aria-label="Cambiar país o moneda"] .subheading'
    ).forEach((label) => {
      if (label.dataset.ohCompactLocale === 'true') return;
      const match = label.textContent.trim().match(/\(([^()]*)\)$/);
      if (!match) return;
      label.textContent = match[1].trim().split(/\s+/)[0];
      label.dataset.ohCompactLocale = 'true';
    });
  }

  function applyAll() {
    applySupportClasses();
    improveSupportSemantics();
    document.querySelectorAll('.footer x-popover.popover').forEach(enhanceLocalizationPopover);
    compactMenuDrawerLocaleLabels();
    applyMotiveStyles();
  }

  document.addEventListener('pointerdown', (event) => hydrateFromTrigger(event.target), true);
  document.addEventListener('click', (event) => hydrateFromTrigger(event.target), true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') hydrateFromTrigger(event.target);
  }, true);

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      applyAll();
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });
  applyAll();

  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (applyMotiveStyles() || attempts >= 120) window.clearInterval(timer);
  }, 500);
})();


/* OH MOTIVE READINESS GUARD V10 · 2026-07-21 */
(() => {
  'use strict';
  if (window.__ohMotiveReadinessGuardV10) return;
  window.__ohMotiveReadinessGuardV10 = true;

  const MAX_WAIT_MS = 8000;
  const POLL_MS = 50;
  const CONSUMED_GESTURE_MS = 700;
  const TRIGGER_SELECTOR = 'header .header__search-link, header [aria-controls="search-drawer"]';
  const INTERCEPT_EVENTS = ['pointerdown', 'touchstart', 'mousedown', 'click'];
  const STYLE_ID = 'oh-motive-readiness-v10-style';
  const STATUS_ID = 'oh-motive-readiness-v10-status';
  const previousBusy = new WeakMap();
  const state = {
    intent: null,
    nextIntentId: 0,
    consumedUntil: 0,
    fallbackCalls: 0,
    directCalls: 0
  };

  function now() {
    return window.performance?.now?.() ?? Date.now();
  }

  function ensureBusyStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      header [data-oh-search-readiness="waiting"] {
        position: relative !important;
        cursor: progress !important;
      }
      header [data-oh-search-readiness="waiting"] > svg,
      header [data-oh-search-readiness="waiting"] > span,
      header [data-oh-search-readiness="waiting"] .icon {
        opacity: .24 !important;
      }
      header [data-oh-search-readiness="waiting"]::after {
        content: "";
        position: absolute;
        z-index: 2;
        top: 50%;
        left: 50%;
        width: 16px;
        height: 16px;
        margin: -8px 0 0 -8px;
        box-sizing: border-box;
        border: 1.5px solid currentColor;
        border-inline-end-color: transparent;
        border-radius: 50%;
        pointer-events: none;
        animation: oh-motive-readiness-spin-v10 .72s linear infinite;
      }
      .oh-motive-readiness-v10-status {
        position: fixed !important;
        inline-size: 1px !important;
        block-size: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
      }
      @keyframes oh-motive-readiness-spin-v10 {
        to { transform: rotate(360deg); }
      }
      @media (prefers-reduced-motion: reduce) {
        header [data-oh-search-readiness="waiting"]::after {
          animation: none;
          border-inline-end-color: currentColor;
          opacity: .62;
        }
      }
    `;
    (document.head || document.documentElement).append(style);
  }

  function ensureStatus() {
    let status = document.getElementById(STATUS_ID);
    if (status) return status;
    status = document.createElement('span');
    status.id = STATUS_ID;
    status.className = 'oh-motive-readiness-v10-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    (document.body || document.documentElement).append(status);
    return status;
  }

  function waitingLabel() {
    const language = (document.documentElement.lang || 'es').toLowerCase().split('-')[0];
    return ({
      es: 'Preparando la búsqueda…',
      en: 'Preparing search…',
      fr: 'Préparation de la recherche…',
      de: 'Suche wird vorbereitet…',
      it: 'Preparazione della ricerca…',
      pt: 'A preparar a pesquisa…',
      ru: 'Подготовка поиска…',
      zh: '正在准备搜索…'
    })[language] || 'Preparing search…';
  }

  function setBusy(trigger, busy) {
    if (!(trigger instanceof Element)) return;
    ensureBusyStyle();
    const status = ensureStatus();
    if (busy) {
      if (!previousBusy.has(trigger)) previousBusy.set(trigger, trigger.getAttribute('aria-busy'));
      trigger.setAttribute('aria-busy', 'true');
      trigger.setAttribute('data-oh-search-readiness', 'waiting');
      status.textContent = waitingLabel();
      return;
    }
    const prior = previousBusy.get(trigger);
    if (prior === null || prior === undefined) trigger.removeAttribute('aria-busy');
    else trigger.setAttribute('aria-busy', prior);
    previousBusy.delete(trigger);
    trigger.removeAttribute('data-oh-search-readiness');
    status.textContent = '';
  }

  function motiveRoot() {
    return document.querySelector('#motive-container')?.shadowRoot || null;
  }

  function motiveIsReady() {
    const root = motiveRoot();
    return typeof window.InterfaceX?.search === 'function' && Boolean(root?.querySelector('#motive-x'));
  }

  function motiveIsVisible() {
    const root = motiveRoot();
    const modal = root?.querySelector('.x-modal.x-mot-main-modal, [role="dialog"]');
    const input = root?.querySelector('.x-mot-search-box__input, input[type="search"]');
    if (!modal || !input) return false;
    const rect = modal.getBoundingClientRect();
    const style = window.getComputedStyle(modal);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  }

  function triggerFromEvent(event) {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    for (const node of path) {
      if (!(node instanceof Element)) continue;
      if (node.matches(TRIGGER_SELECTOR)) {
        return node.matches('a, button') ? node : node.querySelector('a, button') || node;
      }
    }
    const matched = event.target instanceof Element ? event.target.closest(TRIGGER_SELECTOR) : null;
    return matched?.matches('a, button') ? matched : matched?.querySelector('a, button') || matched;
  }

  function cancelVendorPath(event) {
    if (event.cancelable) event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
  }

  function clearIntentTimers(intent) {
    if (intent.pollTimer) window.clearInterval(intent.pollTimer);
    if (intent.deadlineTimer) window.clearTimeout(intent.deadlineTimer);
    intent.pollTimer = 0;
    intent.deadlineTimer = 0;
  }

  function finishIntent(intent) {
    if (state.intent !== intent) return;
    clearIntentTimers(intent);
    setBusy(intent.trigger, false);
    state.consumedUntil = now() + CONSUMED_GESTURE_MS;
    state.intent = null;
  }

  function nativeDrawerFallback(intent, reason) {
    if (state.intent !== intent || intent.fallbackUsed) return;
    intent.fallbackUsed = true;
    intent.fallbackReason = reason;
    state.fallbackCalls += 1;
    const drawer = document.getElementById('search-drawer');
    try {
      if (drawer && typeof drawer.show === 'function') {
        const result = drawer.show({ activator: intent.trigger });
        if (result && typeof result.catch === 'function') result.catch(() => {});
      } else if (drawer) {
        drawer.setAttribute('open', '');
        intent.trigger?.setAttribute('aria-expanded', 'true');
      }
    } finally {
      finishIntent(intent);
    }
  }

  function callMotiveOnce(intent) {
    if (state.intent !== intent || intent.directCalled || !motiveIsReady()) return;
    intent.directCalled = true;
    state.directCalls += 1;
    try {
      const result = window.InterfaceX.search();
      if (result && typeof result.catch === 'function') {
        result.catch(() => nativeDrawerFallback(intent, 'motive-rejected'));
      }
    } catch (error) {
      nativeDrawerFallback(intent, 'motive-threw');
    }
  }

  function pollIntent(intent) {
    if (state.intent !== intent) return;
    if (motiveIsVisible()) {
      finishIntent(intent);
      return;
    }
    callMotiveOnce(intent);
  }

  function beginIntent(trigger) {
    if (state.intent) return;
    const intent = {
      id: ++state.nextIntentId,
      trigger,
      startedAt: now(),
      directCalled: false,
      fallbackUsed: false,
      fallbackReason: '',
      pollTimer: 0,
      deadlineTimer: 0
    };
    state.intent = intent;
    setBusy(trigger, true);
    intent.pollTimer = window.setInterval(() => pollIntent(intent), POLL_MS);
    intent.deadlineTimer = window.setTimeout(() => {
      if (state.intent !== intent) return;
      if (motiveIsVisible()) finishIntent(intent);
      else nativeDrawerFallback(intent, 'readiness-timeout');
    }, MAX_WAIT_MS);
    pollIntent(intent);
  }

  function onTriggerIntent(event) {
    const trigger = triggerFromEvent(event);
    if (!trigger) return;
    if (state.intent || now() < state.consumedUntil) {
      cancelVendorPath(event);
      return;
    }
    if (motiveIsReady()) return;
    cancelVendorPath(event);
    beginIntent(trigger);
  }

  ensureBusyStyle();
  INTERCEPT_EVENTS.forEach((eventType) => {
    window.addEventListener(eventType, onTriggerIntent, { capture: true, passive: false });
  });
})();


/* OH MOTIVE INTERNAL COLLECTION FILTER + NO-QUERY LANDSCAPE V12 · 2026-07-21 */
(() => {
  'use strict';
  if (window.__ohMotiveInternalCollectionsV11) return;
  window.__ohMotiveInternalCollectionsV11 = true;

  const STYLE_ID = 'oh-motive-v11-style';
  const HIDDEN_ATTRIBUTE = 'data-oh-motive-internal-collection-hidden-v11';
  const PREVIOUS_HIDDEN_ATTRIBUTE = 'data-oh-motive-v11-previous-hidden';
  const ADDED_ARIA_HIDDEN_ATTRIBUTE = 'data-oh-motive-v11-added-aria-hidden';
  const ADDED_INERT_ATTRIBUTE = 'data-oh-motive-v11-added-inert';
  const INTERNAL_COLLECTIONS = new Set([
    'new! shopify performance sharing is now turned on',
    'tiktok shop eligible (interno)'
  ]);
  const COLLECTION_FACET_NAMES = new Set(['colecciones', 'collections']);
  const CHOICE_SELECTOR = [
    'input[type="checkbox"]',
    'input[type="radio"]',
    '[role="checkbox"]',
    '[role="radio"]',
    '[role="option"]'
  ].join(',');

  function normalizeFacetText(value) {
    return String(value || '')
      .normalize('NFKC')
      .replace(/\s*\(\s*[\d.,\s]+\s*\)\s*$/u, '')
      .replace(/\s+/gu, ' ')
      .trim()
      .toLocaleLowerCase('en');
  }

  function hasExactText(element, values) {
    return Boolean(element && values.has(normalizeFacetText(element.textContent)));
  }

  function smallestExactElements(scope, values) {
    return Array.from(scope.querySelectorAll('*')).filter((element) => {
      if (!hasExactText(element, values)) return false;
      return !Array.from(element.children).some((child) => hasExactText(child, values));
    });
  }

  function findCollectionFacets(root) {
    const facets = new Set();
    smallestExactElements(root, COLLECTION_FACET_NAMES).forEach((heading) => {
      let current = heading.parentElement;
      let depth = 0;
      while (current && depth < 10) {
        const containsInternalValue = smallestExactElements(current, INTERNAL_COLLECTIONS).length > 0;
        if (containsInternalValue && current.querySelector(CHOICE_SELECTOR)) {
          facets.add(current);
          break;
        }
        if (current.matches?.('.x-mot-layout__aside, .x-mot-layout__main-aside')) break;
        current = current.parentElement;
        depth += 1;
      }
    });
    return Array.from(facets);
  }

  function findOptionContainer(textElement, facet) {
    let current = textElement;
    let best = null;
    let depth = 0;
    while (current && current !== facet && depth < 8) {
      const exact = INTERNAL_COLLECTIONS.has(normalizeFacetText(current.textContent));
      const choices = current.matches?.(CHOICE_SELECTOR)
        ? [current]
        : Array.from(current.querySelectorAll?.(CHOICE_SELECTOR) || []);
      if (exact && choices.length === 1) best = current;
      else if (best && !exact) break;
      current = current.parentElement;
      depth += 1;
    }
    return best;
  }

  function optionIsSelected(option) {
    const controls = option.matches?.(CHOICE_SELECTOR)
      ? [option]
      : Array.from(option.querySelectorAll?.(CHOICE_SELECTOR) || []);
    return controls.some((control) => {
      if ('checked' in control && control.checked) return true;
      if (control.getAttribute('aria-checked') === 'true') return true;
      if (control.getAttribute('aria-selected') === 'true') return true;
      if (control.getAttribute('data-selected') === 'true') return true;
      return /(^|[-_])(selected|checked|active)([-_]|$)/i.test(control.className || '');
    }) || option.getAttribute('aria-checked') === 'true'
      || option.getAttribute('aria-selected') === 'true'
      || option.getAttribute('data-selected') === 'true'
      || /(^|[-_])(selected|checked|active)([-_]|$)/i.test(option.className || '');
  }

  function hideOption(option) {
    if (option.getAttribute(HIDDEN_ATTRIBUTE) === 'true') return;
    option.setAttribute(PREVIOUS_HIDDEN_ATTRIBUTE, String(option.hidden));
    option.setAttribute(ADDED_ARIA_HIDDEN_ATTRIBUTE, String(!option.hasAttribute('aria-hidden')));
    option.setAttribute(ADDED_INERT_ATTRIBUTE, String(!option.hasAttribute('inert')));
    option.setAttribute(HIDDEN_ATTRIBUTE, 'true');
    option.hidden = true;
    option.setAttribute('aria-hidden', 'true');
    option.setAttribute('inert', '');
  }

  function restoreOwnedOption(option) {
    if (option.getAttribute(HIDDEN_ATTRIBUTE) !== 'true') return;
    const wasHidden = option.getAttribute(PREVIOUS_HIDDEN_ATTRIBUTE) === 'true';
    const addedAriaHidden = option.getAttribute(ADDED_ARIA_HIDDEN_ATTRIBUTE) === 'true';
    const addedInert = option.getAttribute(ADDED_INERT_ATTRIBUTE) === 'true';
    option.removeAttribute(HIDDEN_ATTRIBUTE);
    option.hidden = wasHidden;
    if (addedAriaHidden) option.removeAttribute('aria-hidden');
    if (addedInert) option.removeAttribute('inert');
    option.removeAttribute(PREVIOUS_HIDDEN_ATTRIBUTE);
    option.removeAttribute(ADDED_ARIA_HIDDEN_ATTRIBUTE);
    option.removeAttribute(ADDED_INERT_ATTRIBUTE);
  }

  function syncInternalCollectionOptions(root) {
    root.querySelectorAll(`[${HIDDEN_ATTRIBUTE}="true"]`).forEach((option) => {
      if (optionIsSelected(option)) restoreOwnedOption(option);
    });
    findCollectionFacets(root).forEach((facet) => {
      smallestExactElements(facet, INTERNAL_COLLECTIONS).forEach((textElement) => {
        const option = findOptionContainer(textElement, facet);
        if (!option) return;
        if (optionIsSelected(option)) restoreOwnedOption(option);
        else hideOption(option);
      });
    });
  }

  function ensureV11Style(root) {
    let style = root.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      root.append(style);
    }
    const css = `
      [${HIDDEN_ATTRIBUTE}="true"] {
        display: none !important;
      }

      @media (max-height: 540px) and (orientation: landscape) {
        .x-modal.x-mot-main-modal.x-no-query,
        .x-modal.x-mot-main-modal.x-no-query > .x-modal__content,
        .x-modal.x-mot-main-modal.x-no-query .x-mot-layout {
          height: 100dvh !important;
          min-height: 100dvh !important;
          max-height: 100dvh !important;
          box-sizing: border-box !important;
        }

        .x-modal.x-mot-main-modal.x-no-query .x-mot-layout__header {
          /* V12 preserves Motive's horizontal header grid. V11 stacked the
             two 116px side rails above/below the centre column. */
          height: 100dvh !important;
          min-height: 100dvh !important;
          max-height: 100dvh !important;
          overflow: hidden !important;
          box-sizing: border-box !important;
        }

        .x-modal.x-mot-main-modal.x-no-query .x-mot-layout__header-middle {
          display: flex !important;
          flex: 1 1 auto !important;
          flex-direction: column !important;
          height: 100dvh !important;
          min-height: 0 !important;
          max-height: 100dvh !important;
          overflow: hidden !important;
          box-sizing: border-box !important;
        }

        .x-modal.x-mot-main-modal.x-no-query .x-mot-empathize {
          flex: 1 1 auto !important;
          height: auto !important;
          min-height: 0 !important;
          max-height: none !important;
          overflow-x: hidden !important;
          overflow-y: auto !important;
          overscroll-behavior: contain !important;
          -webkit-overflow-scrolling: touch;
        }
      }
    `;
    if (style.textContent !== css) style.textContent = css;
  }

  function bindRoot(root) {
    if (!root) return false;
    ensureV11Style(root);
    if (!root.__ohMotiveInternalCollectionsScheduleV11) {
      let frame = 0;
      root.__ohMotiveInternalCollectionsScheduleV11 = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => {
          frame = 0;
          ensureV11Style(root);
          syncInternalCollectionOptions(root);
        });
      };
    }
    if (!root.__ohMotiveInternalCollectionsObserverV11) {
      root.__ohMotiveInternalCollectionsObserverV11 = new MutationObserver(
        () => root.__ohMotiveInternalCollectionsScheduleV11()
      );
      root.__ohMotiveInternalCollectionsObserverV11.observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['checked', 'aria-checked', 'aria-selected', 'data-selected', 'class']
      });
    }
    if (!root.__ohMotiveInternalCollectionsEventsV11) {
      root.__ohMotiveInternalCollectionsEventsV11 = true;
      ['click', 'change', 'input'].forEach((eventName) => {
        root.addEventListener(eventName, () => root.__ohMotiveInternalCollectionsScheduleV11(), true);
      });
    }
    syncInternalCollectionOptions(root);
    return true;
  }

  function bindCurrentRoot() {
    return bindRoot(document.querySelector('#motive-container')?.shadowRoot || null);
  }

  let documentFrame = 0;
  const documentObserver = new MutationObserver(() => {
    if (documentFrame) return;
    documentFrame = window.requestAnimationFrame(() => {
      documentFrame = 0;
      bindCurrentRoot();
    });
  });
  documentObserver.observe(document.documentElement, { childList: true, subtree: true });
  bindCurrentRoot();

  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (bindCurrentRoot() || attempts >= 120) window.clearInterval(timer);
  }, 500);
})();
/* OH_CART_TACTILITY_V2
   Keep one live region outside the drawer's replaceChildren cycle so cart
   quantity/removal updates are announced once and in the active locale. */
(function(){
  'use strict';
  if(window.__ohCartTactilityV2Bound) return;
  window.__ohCartTactilityV2Bound=true;
  var statusId='oh-cart-live-status';
  var announceTimer=0;
  var lastMessage='';

  function ensureStatus(){
    var status=document.getElementById(statusId);
    if(status) return status;
    status=document.createElement('p');
    status.id=statusId;
    status.className='sr-only';
    status.setAttribute('role','status');
    status.setAttribute('aria-live','polite');
    status.setAttribute('aria-atomic','true');
    (document.body||document.documentElement).appendChild(status);
    return status;
  }

  function cleanText(node){
    return node ? String(node.textContent||'').replace(/\s+/g,' ').trim() : '';
  }

  function announceCartChange(cart){
    window.clearTimeout(announceTimer);
    announceTimer=window.setTimeout(function(){
      var drawer=document.querySelector('cart-drawer');
      var heading=drawer&&drawer.querySelector('[slot="header"] h2');
      var empty=drawer&&drawer.querySelector('.empty-state .h5');
      var message=cleanText(heading);
      var emptyText=cleanText(empty);
      if(emptyText && message.indexOf(emptyText)===-1) message+=(message?'. ':'')+emptyText;
      if(cart && typeof cart.item_count==='number'){
        var count=String(cart.item_count);
        if(!message) message=cleanText(drawer&&drawer.getAttribute('aria-label'));
        if(message && message.indexOf(count)===-1) message+=': '+count;
        if(!message) message=count;
      }
      if(!message || message===lastMessage) return;
      lastMessage=message;
      var status=ensureStatus();
      status.textContent='';
      window.setTimeout(function(){ status.textContent=message; },20);
    },160);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',ensureStatus,{once:true});
  }else{
    ensureStatus();
  }
  document.addEventListener('cart:change',function(event){
    announceCartChange(event.detail&&event.detail.cart);
  },true);
})();
